import gql from 'graphql-tag'

export const createOrderMedication = gql`
  mutation CreateOrderMedication($organizationId: ID!, $encounterId: ID!, $diagnosisSnomedId: ID!, $sukiUserId: ID!, $medicationEntry: MedicationEntryInput) {
    createOrderMedication(input: {
      organizationId: $organizationId
      encounterId: $encounterId
      diagnosisSnomedId: $diagnosisSnomedId
      sukiUserId: $sukiUserId
      medicationEntry: $medicationEntry
    }) {
      sukiPatientId
      medicationEntry {
        id
        emrMedicationName
        structuredSig {
          dosage {
            quantity
            unit
          }
          route
          frequency
          durationInDays
          refills
          orderTypeId
        }
        unstructuredSig
      }
    }
  }
`
